import { Modal } from "./Modal";

export { Modal };
